import {Market} from './interfaces/market';
import {Observable, ReplaySubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {ApiService} from './api';

@Injectable({providedIn: 'root'})
export class MarketsService {
  path: string = '/api';
  private marketSource = new ReplaySubject<boolean>(1);
  marketEvent = this.marketSource.asObservable();
  constructor(private apiService: ApiService) {}

  getMarkets(partnerId: any): Observable<Market[]> {
    return this.apiService.get<Market[]>(`${this.path}/airlines/${partnerId}/markets`);
  }

  getMarket(partnerId: any, marketId: number): Observable<Market> {
    return this.apiService.get<Market>(`${this.path}/markets/${marketId}`);
  }

  createMarket(partnerId: any): Observable<Market> {
    return this.apiService.post<Market>(`${this.path}/airlines/${partnerId}/markets`, {});
  }

  updateMarket(market: Market): Observable<Market> {
    return this.apiService
      .put<Market>(`${this.path}/markets/${market.id}`, {
        name: market.name,
        rules: market.rules,
      });
  }

  updateMarketOrder(partnerId: any, marketIds: any[]) {
    return this.apiService
      .post(`${this.path}/airlines/${partnerId}/sort_markets`, {
        ids: marketIds,
      });
  }

  createMarketEvent(status: boolean) {
    this.marketSource.next(status);
  }

  addUasToMarket(marketId: number, uaIds: number[]) {
    return this.apiService
      .post(`${this.path}/markets/${marketId}/add_utas`, {uta_ids: uaIds});
  }
}
